import { InteractionType } from '@azure/msal-browser';
import { GraphService } from '@/components/ms-teams/GraphService';
import { getMSALInstance, getUsername } from '@/components/ms-teams/MSAL';
import { graphEndpoints } from '@/components/ms-teams/configuration';

let subscriptionId = '';

const getProfile = () => {
  GraphService.get(
    getUsername(),
    graphEndpoints.me.scopes,
    graphEndpoints.me.uri,
    InteractionType.Popup,
    getMSALInstance()
  );
};

const subscribePresence = ({ orgId, agentId, notificationsUrl }) => {
  const payload = {
    changeType: 'updated',
    notificationUrl: `${notificationsUrl}/${orgId}/${agentId}`,
    lifecycleNotificationUrl: `${notificationsUrl}/${orgId}/${agentId}`,
    resource: 'communications/presences/' + getMSALInstance().getActiveAccount().localAccountId,
    expirationDateTime: new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString(),
    includeResourceData: false,
    clientState: 'secretClientState'
  };

  GraphService.post(
    getUsername(),
    graphEndpoints.subscriptions.scopes,
    graphEndpoints.subscriptions.uri + `?$filter=id eq '${getMSALInstance().getActiveAccount().localAccountId}'`,
    InteractionType.Popup,
    getMSALInstance(),
    payload
  );
};

function getPresence() {
  GraphService.get(
    getUsername(),
    graphEndpoints.presence.scopes,
    graphEndpoints.presence.uri,
    InteractionType.Popup,
    getMSALInstance()
  );
}

const getSubscriptions = async () => {
  const subscriptions = await GraphService.get(
    getUsername(),
    graphEndpoints.subscriptions.scopes,
    graphEndpoints.subscriptions.uri,
    InteractionType.Popup,
    getMSALInstance()
  );

  subscriptionId = subscriptions.value && subscriptions.value.length && subscriptions.value[0].id;
  return subscriptions;
};

const deleteSubscriptions = () => {
  GraphService.remove(
    getUsername(),
    graphEndpoints.subscriptions.scopes,
    graphEndpoints.subscriptions.uri + `/${subscriptionId}`,
    InteractionType.Popup,
    getMSALInstance()
  );
};

export const GraphAPI = {
  profile: {
    get: getProfile
  },
  presence: {
    get: getPresence
  },
  subscriptions: {
    subscribe: subscribePresence,
    get: getSubscriptions,
    delete: deleteSubscriptions
  }
};
